// extracted by mini-css-extract-plugin
export var tabWrapper = "TabWrapper-module--tabWrapper--eEiGE";
export var noPaddingBottom = "TabWrapper-module--noPaddingBottom--2TNgR";